// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import Header from "../../component/_elements/Header.tsx";
import General from "./General.tsx";
import { OutletContextType } from "../../types/GlobalType";
import Scolarite from "./Scolarite.tsx";
import Student from "./Student.tsx";
import Personal from "./Personal.tsx";
import Parent from "./Parent.tsx";
import User from "./User.tsx";
const Parametre: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("general");
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isNewFeeModalOpen, setIsNewFeeModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [showCropModal, setShowCropModal] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [activeFormTab, setActiveFormTab] = useState("personal");
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [activeViewTab, setActiveViewTab] = useState("personal");

  const [newFeeForm, setNewFeeForm] = useState({
    name: "",
    description: "",
    defaultAmount: "",
    frequency: "monthly",
    isRequired: false,
  });

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteConfirmed, setDeleteConfirmed] = useState(false);
  const [isNewUserModalOpen, setIsNewUserModalOpen] = useState(false);
  const [isNewRoleModalOpen, setIsNewRoleModalOpen] = useState(false);
  const [newUserForm, setNewUserForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "enseignant",
    password: "",
    confirmPassword: "",
    isActive: true,
  });

  const [studentFilter, setStudentFilter] = useState({
    schoolYear: "2025 - 2026",
    status: "all",
    isYearDropdownOpen: false,
    isStatusDropdownOpen: false,
    currentPage: 1,
    itemsPerPage: 10,
  });
  const [studentStats, setStudentStats] = useState({
    total: 450,
    assigned: 380,
    unassigned: 45,
    archived: 25,
  });
  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const yearFilterBtn = document.getElementById("yearFilterBtn");
      const statusFilterBtn = document.getElementById("statusFilterBtn");
      if (yearFilterBtn && !yearFilterBtn.contains(event.target as Node)) {
        setStudentFilter((prev) => ({
          ...prev,
          isYearDropdownOpen: false,
        }));
      }
      if (statusFilterBtn && !statusFilterBtn.contains(event.target as Node)) {
        setStudentFilter((prev) => ({
          ...prev,
          isStatusDropdownOpen: false,
        }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePhotoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        alert(
          "Le fichier est trop volumineux. La taille maximale est de 10MB."
        );
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const result = e.target?.result as string;
        setSelectedImage(result);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const [newRoleForm, setNewRoleForm] = useState({
    name: "",
    description: "",
    permissions: {
      dashboard: false,
      students: false,
      teachers: false,
      attendance: false,
      payments: false,
      communications: false,
      events: false,
      settings: false,
    },
  });
  const [newUserErrors, setNewUserErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const handleDelete = (item: any) => {
    setItemToDelete(item);
    setIsDeleteModalOpen(true);
    setDeleteConfirmed(false);
  };
  const confirmDelete = () => {
    if (deleteConfirmed) {
      // Here you would typically make an API call to delete the item
      console.log("Deleting item:", itemToDelete);
      setIsDeleteModalOpen(false);
      setItemToDelete(null);
      setDeleteConfirmed(false);
    }
  };
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPasswordForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear errors when user types
    setPasswordErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const validatePasswordForm = () => {
    const errors = {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
    if (!passwordForm.currentPassword) {
      errors.currentPassword = "Le mot de passe actuel est requis";
    }
    if (!passwordForm.newPassword) {
      errors.newPassword = "Le nouveau mot de passe est requis";
    } else if (passwordForm.newPassword.length < 8) {
      errors.newPassword =
        "Le mot de passe doit contenir au moins 8 caractères";
    } else if (
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/.test(
        passwordForm.newPassword
      )
    ) {
      errors.newPassword =
        "Le mot de passe doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial";
    }
    if (!passwordForm.confirmPassword) {
      errors.confirmPassword = "La confirmation du mot de passe est requise";
    } else if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      errors.confirmPassword = "Les mots de passe ne correspondent pas";
    }
    setPasswordErrors(errors);
    return !Object.values(errors).some((error) => error !== "");
  };
  const handlePasswordSubmit = () => {
    if (validatePasswordForm()) {
      // Here you would typically make an API call to update the password
      console.log("Password updated successfully");
      setIsPasswordModalOpen(false);
      setPasswordForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    }
  };
  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };
  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  return (
    <div className="ml-60 w-full">
      {/* Header */}
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />
      {/* Settings Content */}
      <main className="p-6 mt-16">
        <div className="mb-6">
          <h1 className="text-2xl font-bold mb-1">Paramètres</h1>
          <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
            Configurez les options et préférences de l'application
          </p>
        </div>
        {/* Tabs */}
        <div className="mb-6 border-b border-gray-700">
          <div className="flex flex-wrap -mb-px">
            <button
              onClick={() => setActiveTab("general")}
              className={`mr-2 inline-block py-3 px-4 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap !rounded-button ${
                activeTab === "general"
                  ? `${
                      isDarkMode
                        ? "border-blue-500 text-blue-500"
                        : "border-blue-500 text-blue-600"
                    }`
                  : `${
                      isDarkMode
                        ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`
              }`}
            >
              <i className="fas fa-cog mr-2"></i>Général
            </button>
            <button
              onClick={() => setActiveTab("scolarite")}
              className={`mr-2 inline-block py-3 px-4 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap !rounded-button ${
                activeTab === "scolarite"
                  ? `${
                      isDarkMode
                        ? "border-blue-500 text-blue-500"
                        : "border-blue-500 text-blue-600"
                    }`
                  : `${
                      isDarkMode
                        ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`
              }`}
            >
              <i className="fas fa-graduation-cap mr-2"></i>Scolarité
            </button>
            <button
              onClick={() => setActiveTab("eleves")}
              className={`mr-2 inline-block py-3 px-4 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap !rounded-button ${
                activeTab === "eleves"
                  ? `border-b-2 ${
                      isDarkMode
                        ? "border-blue-500 text-blue-500"
                        : "border-blue-600 text-blue-600"
                    }`
                  : `${
                      isDarkMode
                        ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`
              }
            `}
            >
              <i className="fas fa-user-graduate mr-2"></i>Élèves
            </button>
            <button
              onClick={() => setActiveTab("personnel")}
              className={`mr-2 inline-block py-3 px-4 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap !rounded-button ${
                activeTab === "personnel"
                  ? `border-b-2 ${
                      isDarkMode
                        ? "border-blue-500 text-blue-500"
                        : "border-blue-600 text-blue-600"
                    }`
                  : `${
                      isDarkMode
                        ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`
              }
              `}
            >
              <i className="fas fa-users-cog mr-2"></i>Personnel
            </button>
            <button
              onClick={() => setActiveTab("parents")}
              className={`mr-2 inline-block py-3 px-4 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap !rounded-button ${
                activeTab === "parents"
                  ? `border-b-2 ${
                      isDarkMode
                        ? "border-blue-500 text-blue-500"
                        : "border-blue-600 text-blue-600"
                    }`
                  : `${
                      isDarkMode
                        ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`
              }
`}
            >
              <i className="fas fa-users mr-2"></i>Parents
            </button>
            {/* <button
              onClick={() => setActiveTab("users")}
              className={`mr-2 inline-block py-3 px-4 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap !rounded-button ${
                activeTab === "users"
                  ? `${
                      isDarkMode
                        ? "border-blue-500 text-blue-500"
                        : "border-blue-500 text-blue-600"
                    }`
                  : `${
                      isDarkMode
                        ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`
              }`}
            >
              <i className="fas fa-users mr-2"></i>Utilisateurs
            </button> */}
            {/* <button
              onClick={() => setActiveTab("roles")}
              className={`mr-2 inline-block py-3 px-4 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap !rounded-button ${
                activeTab === "roles"
                  ? `${
                      isDarkMode
                        ? "border-blue-500 text-blue-500"
                        : "border-blue-500 text-blue-600"
                    }`
                  : `${
                      isDarkMode
                        ? "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`
              }`}
            >
              <i className="fas fa-user-shield mr-2"></i>Rôles
            </button> */}
          </div>
        </div>
        {/* Tab Content */}
        <div
          className={`${
            isDarkMode ? "bg-[#161B22]" : "bg-white"
          } rounded-lg p-6 border ${
            isDarkMode ? "border-gray-700" : "border-gray-300"
          }`}
        >
          {/* General Settings */}
          {activeTab === "general" && <General />}
          {/* Scolarité Settings */}
          {activeTab === "scolarite" && <Scolarite />}
          {/* Eleve Tab Content */}
          {activeTab === "eleves" && <Student />}
          {/* Personal Settings */}
          {activeTab === "personnel" && <Personal />}
          {/* Parents Settings */}

          {activeTab === "parents" && <Parent />}
          {/* Users Settings */}
          {activeTab === "users" && <User />}
          {/* Roles Settings */}
          {activeTab === "roles" && (
            <div>
              <h2 className="text-xl font-semibold mb-4">Gestion des rôles</h2>
              <p
                className={`mb-6 ${
                  isDarkMode ? "text-gray-400" : "text-gray-600"
                }`}
              >
                Configurez les rôles et les permissions des utilisateurs
              </p>
              <div className="mb-6 flex justify-between items-center">
                <div className="relative w-64">
                  <div
                    className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
                  >
                    <i className="fas fa-search"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="Rechercher un rôle..."
                    className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
                      isDarkMode
                        ? "bg-[#161B22] border-gray-700"
                        : "bg-white border-gray-300"
                    } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                </div>
                <button
                  onClick={() => setIsNewRoleModalOpen(true)}
                  className={`flex items-center px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-blue-600 hover:bg-blue-700"
                      : "bg-blue-500 hover:bg-blue-600"
                  } text-white !rounded-button whitespace-nowrap`}
                >
                  <i className="fas fa-plus-circle mr-2"></i>
                  <span>Nouveau rôle</span>
                </button>
                {isNewRoleModalOpen && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div
                      className={`${
                        isDarkMode ? "bg-[#161B22]" : "bg-white"
                      } rounded-lg p-6 w-full max-w-lg`}
                    >
                      <h3 className="text-xl font-semibold mb-4">
                        Créer un nouveau rôle
                      </h3>
                      <div className="space-y-4">
                        <div>
                          <label
                            className={`block text-sm font-medium mb-1 ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Nom du rôle
                          </label>
                          <input
                            type="text"
                            value={newRoleForm.name}
                            onChange={(e) =>
                              setNewRoleForm({
                                ...newRoleForm,
                                name: e.target.value,
                              })
                            }
                            className={`w-full px-3 py-2 rounded-md border ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700 text-white"
                                : "bg-white border-gray-300"
                            } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            placeholder="Ex: Responsable pédagogique"
                          />
                        </div>
                        <div>
                          <label
                            className={`block text-sm font-medium mb-1 ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Description
                          </label>
                          <textarea
                            value={newRoleForm.description}
                            onChange={(e) =>
                              setNewRoleForm({
                                ...newRoleForm,
                                description: e.target.value,
                              })
                            }
                            className={`w-full px-3 py-2 rounded-md border ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700 text-white"
                                : "bg-white border-gray-300"
                            } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            rows={3}
                            placeholder="Description des responsabilités et accès"
                          />
                        </div>
                        <div>
                          <label
                            className={`block text-sm font-medium mb-2 ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Permissions
                          </label>
                          <div className="space-y-2">
                            {Object.entries(newRoleForm.permissions).map(
                              ([key, value]) => (
                                <label key={key} className="flex items-center">
                                  <input
                                    type="checkbox"
                                    checked={value}
                                    onChange={(e) =>
                                      setNewRoleForm({
                                        ...newRoleForm,
                                        permissions: {
                                          ...newRoleForm.permissions,
                                          [key]: e.target.checked,
                                        },
                                      })
                                    }
                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                  />
                                  <span className="ml-2 capitalize">
                                    {key === "dashboard"
                                      ? "Tableau de bord"
                                      : key === "students"
                                      ? "Gestion des élèves"
                                      : key === "teachers"
                                      ? "Gestion des enseignants"
                                      : key === "attendance"
                                      ? "Gestion des présences"
                                      : key === "payments"
                                      ? "Gestion des paiements"
                                      : key === "communications"
                                      ? "Communications"
                                      : key === "events"
                                      ? "Événements"
                                      : "Paramètres"}
                                  </span>
                                </label>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="mt-6 flex justify-end space-x-3">
                        <button
                          onClick={() => {
                            setIsNewRoleModalOpen(false);
                            setNewRoleForm({
                              name: "",
                              description: "",
                              permissions: {
                                dashboard: false,
                                students: false,
                                teachers: false,
                                attendance: false,
                                payments: false,
                                communications: false,
                                events: false,
                                settings: false,
                              },
                            });
                          }}
                          className={`px-4 py-2 rounded-md ${
                            isDarkMode
                              ? "bg-gray-700 hover:bg-gray-600"
                              : "bg-gray-200 hover:bg-gray-300"
                          } !rounded-button whitespace-nowrap`}
                        >
                          Annuler
                        </button>
                        <button
                          onClick={() => {
                            // Here you would typically make an API call to save the new role
                            console.log("New role:", newRoleForm);
                            setIsNewRoleModalOpen(false);
                            setNewRoleForm({
                              name: "",
                              description: "",
                              permissions: {
                                dashboard: false,
                                students: false,
                                teachers: false,
                                attendance: false,
                                payments: false,
                                communications: false,
                                events: false,
                                settings: false,
                              },
                            });
                          }}
                          className={`px-4 py-2 rounded-md ${
                            isDarkMode
                              ? "bg-blue-600 hover:bg-blue-700"
                              : "bg-blue-500 hover:bg-blue-600"
                          } text-white !rounded-button whitespace-nowrap`}
                        >
                          Créer
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`rounded-lg overflow-hidden border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } mb-6`}
              >
                <table className="min-w-full divide-y divide-gray-700">
                  <thead
                    className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
                  >
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                      >
                        Rôle
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                      >
                        Description
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                      >
                        Utilisateurs
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    className={`${
                      isDarkMode ? "bg-[#0D1117]" : "bg-white"
                    } divide-y ${
                      isDarkMode ? "divide-gray-700" : "divide-gray-200"
                    }`}
                  >
                    <tr
                      className={`${
                        isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                      }`}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="font-medium">Administrateur</div>
                      </td>
                      <td className="px-6 py-4">
                        <div
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Accès complet à toutes les fonctionnalités et
                          paramètres du système
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                          2 utilisateurs
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-3">
                          <button
                            onClick={(e) => {
                              const button = e.target.closest("button");
                              if (!button) return;
                              const row = button.closest("tr");
                              if (!row) return;
                              // Get active tab to determine context
                              const activeTabElement = document.querySelector(
                                '[role="tab"][aria-selected="true"]'
                              );
                              const context =
                                activeTabElement?.getAttribute("data-tab") ||
                                activeTab;
                              let itemData = {};
                              // Extract data based on context
                              switch (context) {
                                case "users":
                                  itemData = {
                                    firstName:
                                      row
                                        .querySelector("#userName")
                                        ?.textContent?.split(" ")[0] || "",
                                    lastName:
                                      row
                                        .querySelector("#userName")
                                        ?.textContent?.split(" ")[1] || "",
                                    email:
                                      row.querySelector("#userEmail")
                                        ?.textContent || "",
                                    role:
                                      row
                                        .querySelector("#userRole")
                                        ?.textContent?.toLowerCase() || "",
                                    isActive:
                                      row
                                        .querySelector("#userStatus")
                                        ?.textContent?.includes("Actif") ||
                                      false,
                                  };
                                  setNewUserForm(itemData);
                                  setIsNewUserModalOpen(true);
                                  break;
                                case "roles":
                                  itemData = {
                                    name:
                                      row.querySelector("#roleName")
                                        ?.textContent || "",
                                    description:
                                      row.querySelector("#roleDescription")
                                        ?.textContent || "",
                                    permissions: {
                                      dashboard:
                                        row.querySelector("#permDashboard")
                                          ?.checked || false,
                                      students:
                                        row.querySelector("#permStudents")
                                          ?.checked || false,
                                      teachers:
                                        row.querySelector("#permTeachers")
                                          ?.checked || false,
                                      attendance:
                                        row.querySelector("#permAttendance")
                                          ?.checked || false,
                                      payments:
                                        row.querySelector("#permPayments")
                                          ?.checked || false,
                                      communications:
                                        row.querySelector("#permCommunications")
                                          ?.checked || false,
                                      events:
                                        row.querySelector("#permEvents")
                                          ?.checked || false,
                                      settings:
                                        row.querySelector("#permSettings")
                                          ?.checked || false,
                                    },
                                  };
                                  setNewRoleForm(itemData);
                                  setIsNewRoleModalOpen(true);
                                  break;
                                case "payments":
                                  itemData = {
                                    name:
                                      row.querySelector("#feeName")
                                        ?.textContent || "",
                                    description:
                                      row.querySelector("#feeDescription")
                                        ?.textContent || "",
                                    defaultAmount:
                                      row
                                        .querySelector("#feeAmount")
                                        ?.textContent?.replace(
                                          /[^0-9.]/g,
                                          ""
                                        ) || "",
                                    frequency:
                                      row
                                        .querySelector("#feeFrequency")
                                        ?.textContent?.toLowerCase() ||
                                      "monthly",
                                    isRequired:
                                      row.querySelector("#feeRequired")
                                        ?.checked || false,
                                  };
                                  setNewFeeForm(itemData);
                                  setIsNewFeeModalOpen(true);
                                  break;
                                default:
                                  console.warn(
                                    "Unknown context for edit operation"
                                  );
                                  return;
                              }
                              setSelectedItem(itemData);
                            }}
                            className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            onClick={() =>
                              handleDelete({
                                id: "unique-id",
                                type: "user",
                              })
                            }
                            className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                          {isDeleteModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                              <div
                                className={`${
                                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                                } rounded-lg p-6 w-full max-w-md`}
                              >
                                <div className="flex items-center mb-4">
                                  <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                                    <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                                  </div>
                                  <h3 className="text-xl font-semibold ml-4">
                                    Confirmer la suppression
                                  </h3>
                                </div>
                                <p
                                  className={`mb-6 ${
                                    isDarkMode
                                      ? "text-gray-400"
                                      : "text-gray-600"
                                  }`}
                                >
                                  Êtes-vous sûr de vouloir supprimer cet élément
                                  ? Cette action est irréversible et toutes les
                                  données associées seront définitivement
                                  perdues.
                                </p>
                                <div className="mb-4">
                                  <label className="flex items-center">
                                    <input
                                      type="checkbox"
                                      checked={deleteConfirmed}
                                      onChange={(e) =>
                                        setDeleteConfirmed(e.target.checked)
                                      }
                                      className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                                    />
                                    <span className="ml-2 text-sm">
                                      Je comprends que cette action est
                                      irréversible
                                    </span>
                                  </label>
                                </div>
                                <div className="flex justify-end space-x-3">
                                  <button
                                    onClick={() => {
                                      setIsDeleteModalOpen(false);
                                      setItemToDelete(null);
                                      setDeleteConfirmed(false);
                                    }}
                                    className={`px-4 py-2 rounded-md ${
                                      isDarkMode
                                        ? "bg-gray-700 hover:bg-gray-600"
                                        : "bg-gray-200 hover:bg-gray-300"
                                    } !rounded-button whitespace-nowrap`}
                                  >
                                    Annuler
                                  </button>
                                  <button
                                    onClick={confirmDelete}
                                    disabled={!deleteConfirmed}
                                    className={`px-4 py-2 rounded-md ${
                                      deleteConfirmed
                                        ? "bg-red-600 hover:bg-red-700"
                                        : "bg-red-300 cursor-not-allowed"
                                    } text-white !rounded-button whitespace-nowrap`}
                                  >
                                    Supprimer
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr
                      className={`${
                        isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                      }`}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="font-medium">Enseignant</div>
                      </td>
                      <td className="px-6 py-4">
                        <div
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Gestion des classes, des élèves et des notes
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-purple-100 text-purple-800">
                          15 utilisateurs
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-3">
                          <button
                            onClick={(e) => {
                              const button = e.target.closest("button");
                              if (!button) return;
                              const row = button.closest("tr");
                              if (!row) return;
                              // Get active tab to determine context
                              const activeTabElement = document.querySelector(
                                '[role="tab"][aria-selected="true"]'
                              );
                              const context =
                                activeTabElement?.getAttribute("data-tab") ||
                                activeTab;
                              let itemData = {};
                              // Extract data based on context
                              switch (context) {
                                case "users":
                                  itemData = {
                                    firstName:
                                      row
                                        .querySelector("#userName")
                                        ?.textContent?.split(" ")[0] || "",
                                    lastName:
                                      row
                                        .querySelector("#userName")
                                        ?.textContent?.split(" ")[1] || "",
                                    email:
                                      row.querySelector("#userEmail")
                                        ?.textContent || "",
                                    role:
                                      row
                                        .querySelector("#userRole")
                                        ?.textContent?.toLowerCase() || "",
                                    isActive:
                                      row
                                        .querySelector("#userStatus")
                                        ?.textContent?.includes("Actif") ||
                                      false,
                                  };
                                  setNewUserForm(itemData);
                                  setIsNewUserModalOpen(true);
                                  break;
                                case "roles":
                                  itemData = {
                                    name:
                                      row.querySelector("#roleName")
                                        ?.textContent || "",
                                    description:
                                      row.querySelector("#roleDescription")
                                        ?.textContent || "",
                                    permissions: {
                                      dashboard:
                                        row.querySelector("#permDashboard")
                                          ?.checked || false,
                                      students:
                                        row.querySelector("#permStudents")
                                          ?.checked || false,
                                      teachers:
                                        row.querySelector("#permTeachers")
                                          ?.checked || false,
                                      attendance:
                                        row.querySelector("#permAttendance")
                                          ?.checked || false,
                                      payments:
                                        row.querySelector("#permPayments")
                                          ?.checked || false,
                                      communications:
                                        row.querySelector("#permCommunications")
                                          ?.checked || false,
                                      events:
                                        row.querySelector("#permEvents")
                                          ?.checked || false,
                                      settings:
                                        row.querySelector("#permSettings")
                                          ?.checked || false,
                                    },
                                  };
                                  setNewRoleForm(itemData);
                                  setIsNewRoleModalOpen(true);
                                  break;
                                case "payments":
                                  itemData = {
                                    name:
                                      row.querySelector("#feeName")
                                        ?.textContent || "",
                                    description:
                                      row.querySelector("#feeDescription")
                                        ?.textContent || "",
                                    defaultAmount:
                                      row
                                        .querySelector("#feeAmount")
                                        ?.textContent?.replace(
                                          /[^0-9.]/g,
                                          ""
                                        ) || "",
                                    frequency:
                                      row
                                        .querySelector("#feeFrequency")
                                        ?.textContent?.toLowerCase() ||
                                      "monthly",
                                    isRequired:
                                      row.querySelector("#feeRequired")
                                        ?.checked || false,
                                  };
                                  setNewFeeForm(itemData);
                                  setIsNewFeeModalOpen(true);
                                  break;
                                default:
                                  console.warn(
                                    "Unknown context for edit operation"
                                  );
                                  return;
                              }
                              setSelectedItem(itemData);
                            }}
                            className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            onClick={() =>
                              handleDelete({
                                id: "unique-id",
                                type: "user",
                              })
                            }
                            className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                          {isDeleteModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                              <div
                                className={`${
                                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                                } rounded-lg p-6 w-full max-w-md`}
                              >
                                <div className="flex items-center mb-4">
                                  <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                                    <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                                  </div>
                                  <h3 className="text-xl font-semibold ml-4">
                                    Confirmer la suppression
                                  </h3>
                                </div>
                                <p
                                  className={`mb-6 ${
                                    isDarkMode
                                      ? "text-gray-400"
                                      : "text-gray-600"
                                  }`}
                                >
                                  Êtes-vous sûr de vouloir supprimer cet élément
                                  ? Cette action est irréversible et toutes les
                                  données associées seront définitivement
                                  perdues.
                                </p>
                                <div className="mb-4">
                                  <label className="flex items-center">
                                    <input
                                      type="checkbox"
                                      checked={deleteConfirmed}
                                      onChange={(e) =>
                                        setDeleteConfirmed(e.target.checked)
                                      }
                                      className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                                    />
                                    <span className="ml-2 text-sm">
                                      Je comprends que cette action est
                                      irréversible
                                    </span>
                                  </label>
                                </div>
                                <div className="flex justify-end space-x-3">
                                  <button
                                    onClick={() => {
                                      setIsDeleteModalOpen(false);
                                      setItemToDelete(null);
                                      setDeleteConfirmed(false);
                                    }}
                                    className={`px-4 py-2 rounded-md ${
                                      isDarkMode
                                        ? "bg-gray-700 hover:bg-gray-600"
                                        : "bg-gray-200 hover:bg-gray-300"
                                    } !rounded-button whitespace-nowrap`}
                                  >
                                    Annuler
                                  </button>
                                  <button
                                    onClick={confirmDelete}
                                    disabled={!deleteConfirmed}
                                    className={`px-4 py-2 rounded-md ${
                                      deleteConfirmed
                                        ? "bg-red-600 hover:bg-red-700"
                                        : "bg-red-300 cursor-not-allowed"
                                    } text-white !rounded-button whitespace-nowrap`}
                                  >
                                    Supprimer
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr
                      className={`${
                        isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                      }`}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="font-medium">Parent</div>
                      </td>
                      <td className="px-6 py-4">
                        <div
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Consultation des informations de leurs enfants,
                          paiements
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">
                          187 utilisateurs
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-3">
                          <button
                            onClick={(e) => {
                              const button = e.target.closest("button");
                              if (!button) return;
                              const row = button.closest("tr");
                              if (!row) return;
                              // Get active tab to determine context
                              const activeTabElement = document.querySelector(
                                '[role="tab"][aria-selected="true"]'
                              );
                              const context =
                                activeTabElement?.getAttribute("data-tab") ||
                                activeTab;
                              let itemData = {};
                              // Extract data based on context
                              switch (context) {
                                case "users":
                                  itemData = {
                                    firstName:
                                      row
                                        .querySelector("#userName")
                                        ?.textContent?.split(" ")[0] || "",
                                    lastName:
                                      row
                                        .querySelector("#userName")
                                        ?.textContent?.split(" ")[1] || "",
                                    email:
                                      row.querySelector("#userEmail")
                                        ?.textContent || "",
                                    role:
                                      row
                                        .querySelector("#userRole")
                                        ?.textContent?.toLowerCase() || "",
                                    isActive:
                                      row
                                        .querySelector("#userStatus")
                                        ?.textContent?.includes("Actif") ||
                                      false,
                                  };
                                  setNewUserForm(itemData);
                                  setIsNewUserModalOpen(true);
                                  break;
                                case "roles":
                                  itemData = {
                                    name:
                                      row.querySelector("#roleName")
                                        ?.textContent || "",
                                    description:
                                      row.querySelector("#roleDescription")
                                        ?.textContent || "",
                                    permissions: {
                                      dashboard:
                                        row.querySelector("#permDashboard")
                                          ?.checked || false,
                                      students:
                                        row.querySelector("#permStudents")
                                          ?.checked || false,
                                      teachers:
                                        row.querySelector("#permTeachers")
                                          ?.checked || false,
                                      attendance:
                                        row.querySelector("#permAttendance")
                                          ?.checked || false,
                                      payments:
                                        row.querySelector("#permPayments")
                                          ?.checked || false,
                                      communications:
                                        row.querySelector("#permCommunications")
                                          ?.checked || false,
                                      events:
                                        row.querySelector("#permEvents")
                                          ?.checked || false,
                                      settings:
                                        row.querySelector("#permSettings")
                                          ?.checked || false,
                                    },
                                  };
                                  setNewRoleForm(itemData);
                                  setIsNewRoleModalOpen(true);
                                  break;
                                case "payments":
                                  itemData = {
                                    name:
                                      row.querySelector("#feeName")
                                        ?.textContent || "",
                                    description:
                                      row.querySelector("#feeDescription")
                                        ?.textContent || "",
                                    defaultAmount:
                                      row
                                        .querySelector("#feeAmount")
                                        ?.textContent?.replace(
                                          /[^0-9.]/g,
                                          ""
                                        ) || "",
                                    frequency:
                                      row
                                        .querySelector("#feeFrequency")
                                        ?.textContent?.toLowerCase() ||
                                      "monthly",
                                    isRequired:
                                      row.querySelector("#feeRequired")
                                        ?.checked || false,
                                  };
                                  setNewFeeForm(itemData);
                                  setIsNewFeeModalOpen(true);
                                  break;
                                default:
                                  console.warn(
                                    "Unknown context for edit operation"
                                  );
                                  return;
                              }
                              setSelectedItem(itemData);
                            }}
                            className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            onClick={() =>
                              handleDelete({
                                id: "unique-id",
                                type: "user",
                              })
                            }
                            className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                          {isDeleteModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                              <div
                                className={`${
                                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                                } rounded-lg p-6 w-full max-w-md`}
                              >
                                <div className="flex items-center mb-4">
                                  <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                                    <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                                  </div>
                                  <h3 className="text-xl font-semibold ml-4">
                                    Confirmer la suppression
                                  </h3>
                                </div>
                                <p
                                  className={`mb-6 ${
                                    isDarkMode
                                      ? "text-gray-400"
                                      : "text-gray-600"
                                  }`}
                                >
                                  Êtes-vous sûr de vouloir supprimer cet élément
                                  ? Cette action est irréversible et toutes les
                                  données associées seront définitivement
                                  perdues.
                                </p>
                                <div className="mb-4">
                                  <label className="flex items-center">
                                    <input
                                      type="checkbox"
                                      checked={deleteConfirmed}
                                      onChange={(e) =>
                                        setDeleteConfirmed(e.target.checked)
                                      }
                                      className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                                    />
                                    <span className="ml-2 text-sm">
                                      Je comprends que cette action est
                                      irréversible
                                    </span>
                                  </label>
                                </div>
                                <div className="flex justify-end space-x-3">
                                  <button
                                    onClick={() => {
                                      setIsDeleteModalOpen(false);
                                      setItemToDelete(null);
                                      setDeleteConfirmed(false);
                                    }}
                                    className={`px-4 py-2 rounded-md ${
                                      isDarkMode
                                        ? "bg-gray-700 hover:bg-gray-600"
                                        : "bg-gray-200 hover:bg-gray-300"
                                    } !rounded-button whitespace-nowrap`}
                                  >
                                    Annuler
                                  </button>
                                  <button
                                    onClick={confirmDelete}
                                    disabled={!deleteConfirmed}
                                    className={`px-4 py-2 rounded-md ${
                                      deleteConfirmed
                                        ? "bg-red-600 hover:bg-red-700"
                                        : "bg-red-300 cursor-not-allowed"
                                    } text-white !rounded-button whitespace-nowrap`}
                                  >
                                    Supprimer
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr
                      className={`${
                        isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                      }`}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="font-medium">Comptable</div>
                      </td>
                      <td className="px-6 py-4">
                        <div
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Gestion des paiements et des finances
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-indigo-100 text-indigo-800">
                          3 utilisateurs
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-3">
                          <button
                            onClick={(e) => {
                              const button = e.target.closest("button");
                              if (!button) return;
                              const row = button.closest("tr");
                              if (!row) return;
                              // Get active tab to determine context
                              const activeTabElement = document.querySelector(
                                '[role="tab"][aria-selected="true"]'
                              );
                              const context =
                                activeTabElement?.getAttribute("data-tab") ||
                                activeTab;
                              let itemData = {};
                              // Extract data based on context
                              switch (context) {
                                case "users":
                                  itemData = {
                                    firstName:
                                      row
                                        .querySelector("#userName")
                                        ?.textContent?.split(" ")[0] || "",
                                    lastName:
                                      row
                                        .querySelector("#userName")
                                        ?.textContent?.split(" ")[1] || "",
                                    email:
                                      row.querySelector("#userEmail")
                                        ?.textContent || "",
                                    role:
                                      row
                                        .querySelector("#userRole")
                                        ?.textContent?.toLowerCase() || "",
                                    isActive:
                                      row
                                        .querySelector("#userStatus")
                                        ?.textContent?.includes("Actif") ||
                                      false,
                                  };
                                  setNewUserForm(itemData);
                                  setIsNewUserModalOpen(true);
                                  break;
                                case "roles":
                                  itemData = {
                                    name:
                                      row.querySelector("#roleName")
                                        ?.textContent || "",
                                    description:
                                      row.querySelector("#roleDescription")
                                        ?.textContent || "",
                                    permissions: {
                                      dashboard:
                                        row.querySelector("#permDashboard")
                                          ?.checked || false,
                                      students:
                                        row.querySelector("#permStudents")
                                          ?.checked || false,
                                      teachers:
                                        row.querySelector("#permTeachers")
                                          ?.checked || false,
                                      attendance:
                                        row.querySelector("#permAttendance")
                                          ?.checked || false,
                                      payments:
                                        row.querySelector("#permPayments")
                                          ?.checked || false,
                                      communications:
                                        row.querySelector("#permCommunications")
                                          ?.checked || false,
                                      events:
                                        row.querySelector("#permEvents")
                                          ?.checked || false,
                                      settings:
                                        row.querySelector("#permSettings")
                                          ?.checked || false,
                                    },
                                  };
                                  setNewRoleForm(itemData);
                                  setIsNewRoleModalOpen(true);
                                  break;
                                case "payments":
                                  itemData = {
                                    name:
                                      row.querySelector("#feeName")
                                        ?.textContent || "",
                                    description:
                                      row.querySelector("#feeDescription")
                                        ?.textContent || "",
                                    defaultAmount:
                                      row
                                        .querySelector("#feeAmount")
                                        ?.textContent?.replace(
                                          /[^0-9.]/g,
                                          ""
                                        ) || "",
                                    frequency:
                                      row
                                        .querySelector("#feeFrequency")
                                        ?.textContent?.toLowerCase() ||
                                      "monthly",
                                    isRequired:
                                      row.querySelector("#feeRequired")
                                        ?.checked || false,
                                  };
                                  setNewFeeForm(itemData);
                                  setIsNewFeeModalOpen(true);
                                  break;
                                default:
                                  console.warn(
                                    "Unknown context for edit operation"
                                  );
                                  return;
                              }
                              setSelectedItem(itemData);
                            }}
                            className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            onClick={() =>
                              handleDelete({
                                id: "unique-id",
                                type: "user",
                              })
                            }
                            className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                          {isDeleteModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                              <div
                                className={`${
                                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                                } rounded-lg p-6 w-full max-w-md`}
                              >
                                <div className="flex items-center mb-4">
                                  <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                                    <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                                  </div>
                                  <h3 className="text-xl font-semibold ml-4">
                                    Confirmer la suppression
                                  </h3>
                                </div>
                                <p
                                  className={`mb-6 ${
                                    isDarkMode
                                      ? "text-gray-400"
                                      : "text-gray-600"
                                  }`}
                                >
                                  Êtes-vous sûr de vouloir supprimer cet élément
                                  ? Cette action est irréversible et toutes les
                                  données associées seront définitivement
                                  perdues.
                                </p>
                                <div className="mb-4">
                                  <label className="flex items-center">
                                    <input
                                      type="checkbox"
                                      checked={deleteConfirmed}
                                      onChange={(e) =>
                                        setDeleteConfirmed(e.target.checked)
                                      }
                                      className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                                    />
                                    <span className="ml-2 text-sm">
                                      Je comprends que cette action est
                                      irréversible
                                    </span>
                                  </label>
                                </div>
                                <div className="flex justify-end space-x-3">
                                  <button
                                    onClick={() => {
                                      setIsDeleteModalOpen(false);
                                      setItemToDelete(null);
                                      setDeleteConfirmed(false);
                                    }}
                                    className={`px-4 py-2 rounded-md ${
                                      isDarkMode
                                        ? "bg-gray-700 hover:bg-gray-600"
                                        : "bg-gray-200 hover:bg-gray-300"
                                    } !rounded-button whitespace-nowrap`}
                                  >
                                    Annuler
                                  </button>
                                  <button
                                    onClick={confirmDelete}
                                    disabled={!deleteConfirmed}
                                    className={`px-4 py-2 rounded-md ${
                                      deleteConfirmed
                                        ? "bg-red-600 hover:bg-red-700"
                                        : "bg-red-300 cursor-not-allowed"
                                    } text-white !rounded-button whitespace-nowrap`}
                                  >
                                    Supprimer
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className={`p-4 rounded-lg border ${
                  isDarkMode
                    ? "bg-[#0D1117] border-gray-700"
                    : "bg-gray-50 border-gray-200"
                }`}
              >
                <h3 className="text-lg font-medium mb-4">
                  Matrice des permissions
                </h3>
                <div
                  className={`overflow-x-auto ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } rounded-lg border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  }`}
                >
                  <table className="min-w-full divide-y divide-gray-700">
                    <thead
                      className={`${
                        isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"
                      }`}
                    >
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                        >
                          Module / Fonctionnalité
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                        >
                          <div>Administrateur</div>
                          <div className="text-xs font-normal lowercase text-gray-500 mt-1">
                            L / E
                          </div>
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                        >
                          <div>Enseignant</div>
                          <div className="text-xs font-normal lowercase text-gray-500 mt-1">
                            L / E
                          </div>
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                        >
                          <div>Parent</div>
                          <div className="text-xs font-normal lowercase text-gray-500 mt-1">
                            L / E
                          </div>
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                        >
                          <div>Comptable</div>
                          <div className="text-xs font-normal lowercase text-gray-500 mt-1">
                            L / E
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700">
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap font-medium">
                          Tableau de bord
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap font-medium">
                          Gestion des élèves
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap font-medium">
                          Gestion des enseignants
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap font-medium">
                          Gestion des présences
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap font-medium">
                          Gestion des paiements
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap font-medium">
                          Communications
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap font-medium">
                          Événements
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap font-medium">
                          Paramètres
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              defaultChecked
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex justify-center space-x-2">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              title="Lecture"
                            />
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                              title="Écriture"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="mt-6 flex justify-end space-x-3">
                <button
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600"
                      : "bg-gray-200 hover:bg-gray-300"
                  } !rounded-button whitespace-nowrap`}
                >
                  Annuler
                </button>
                <button
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-blue-600 hover:bg-blue-700"
                      : "bg-blue-500 hover:bg-blue-600"
                  } text-white !rounded-button whitespace-nowrap`}
                >
                  Enregistrer les modifications
                </button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};
export default Parametre;
